module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "scrape-hacker-news-top-stories.78a55f9b.png" + "?" + Date.now();